(function () {
    'use strict';

    a3_pilot_reports.factory('CrewHotelFactory', CrewHotelFactory);
    /**
    * @memberof PilotReports
    * @ngdoc factory
    * @name CrewHotelFactory
    * @description 
    * Get hotels
    * @ngInject
    */
    function CrewHotelFactory(GenericService, showHotelsAcTypes) {

        var objType = 'crewHotel';
        var objCallback = CrewHotel;

        var service = {
            getCrewHotelsFromStorage: getCrewHotelsFromStorage,
            setCrewHotelsToStorage: setCrewHotelsToStorage,
            showHotelsInCalendar: showHotelsInCalendar 
        };

        /**
        * Initialize the CrewHotel
        * @memberof CrewHotelFactory
        */
        function CrewHotel() {
            this.AimsId = null;
            this.CrewName = null;
            this.DutyDate = null;
            this.Base = null;
            this.Airport = null;
            this.HotelNo = null;
            this.HotelName = null;
            this.GroundTime = null;
        }

        /**
         * Get Crew Hotels
         * @memberof CrewHotelFactory
         * @returns {Array} CrewHotels 
         */
        function getCrewHotelsFromStorage() {
            return GenericService.list(objType, objCallback);
        }

        /**
         * Save Crew Hotels to storage
         * @memberof GroundDutyFactory
         * @param {Array} objList A list of Crew Hotels
         */
        function setCrewHotelsToStorage(objList) {
            GenericService.saveAll(objList, objType);
        }


        /**
         * Get flights for a specific duty date. Show hotels check depend on ac types
         * @memberof AutolandFactory
         * @param {object} flights the flight object of sync response
         * @returns {bool} showHotelsInCalendar
         */
        function showHotelsInCalendar(flights) {
            var oaFlights = flights.filter(x => x.IsDHC == false && showHotelsAcTypes.includes(x.AcType));
            return oaFlights.length > 0;
        }


        return service;
    }

})();
